"use client";
import React, { useEffect } from "react";
import { useRouter } from "next/navigation";
import { Sidebar } from "@/components/sidebar/sidebar";
import { MainChat } from "@/components/mainchat/mainchat";
import { AuthenticatedTemplate, useIsAuthenticated, useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";

const Home = () => {
    const [sidebarOpen, setSidebarOpen] = React.useState<boolean>(false);
    const props = { sidebarOpen: sidebarOpen, setSidebarOpen: setSidebarOpen };
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();
    const router = useRouter();

    useEffect(() => {
        if (inProgress === InteractionStatus.None && !isAuthenticated) {
            router.push("/signin");
        }
    }, [inProgress, isAuthenticated, router]);

    return (
        <AuthenticatedTemplate>
            <div className={"flex flex-row"}>
                <Sidebar sidebar={props} />
                <MainChat sidebar={props} />
            </div>
        </AuthenticatedTemplate>
    );
};

export default Home;
